














import Vue from 'vue'
import { BatchDto } from '@/Application/Batch'
import SpeciesOfferTableHeader from '@/UI/AuctionB/Declarations/OfferTable/SpeciesOfferTableHeader.vue'
import SpeciesOfferTableRow from '@/UI/AuctionB/Declarations/OfferTable/SpeciesOfferTableRow.vue'
import { ResultasOffer } from '@/Infrastructure/Store/AuctionB/ResultasOffer'

export default Vue.extend({
  name: 'SpeciesOfferTable',
  components: {
    SpeciesOfferTableHeader,
    SpeciesOfferTableRow
  },
  props: {
    batch: {
      type: BatchDto,
      required: true
    },
    offers: {
      type: Array as () => ResultasOffer[]
    }
  },
  methods: {
    getPreviousOffer (internalId: number): ResultasOffer | null {
      const previousOffer = this.offers.find(current => current.internalId === internalId)
      if (!previousOffer) {
        return null
      }
      return previousOffer
    }
  }
})
